import React, {useState, useEffect} from "react";
import { useLanguage } from '../../../hooks/useLanguage';
import SubBanner from "../../../components/SubBanner";
import bannerImg from '../../../assets/img/trader_banner.png';
import AceTraders from '../../../assets/img/Logo_ACE_TRADER_White.svg';
import dmp from "../../../assets/img/dmp.png";
import sub_01 from "../../../assets/icon/sub_01.svg";
import sub_02 from "../../../assets/icon/sub_02.svg";
import sub_03 from "../../../assets/icon/sub_03.svg";
import sub_04 from "../../../assets/icon/sub_04.svg";
import sub_05 from "../../../assets/icon/sub_05.svg";
import sub_06 from "../../../assets/icon/sub_06.svg";
import sub_07 from "../../../assets/icon/sub_07.svg";
import sub_08 from "../../../assets/icon/sub_08.svg";
import format_1 from "../../../assets/img/format_1.png";
import format_2 from "../../../assets/img/format_2.png";
import format_3 from "../../../assets/img/format_3.png";
import format_4 from "../../../assets/img/format_4.png";
import format_5 from "../../../assets/img/format_5.png";
import format_6 from "../../../assets/img/format_6.png";
import format_7 from "../../../assets/img/format_7.png";
import format_8 from "../../../assets/img/format_8.png";
import format_9 from "../../../assets/img/format_9.png";
import format_10 from "../../../assets/img/format_10.png";
import ace_dmp from "../../../assets/img/ace_dmp.svg";
import subLast from "../../../assets/img/sub_last.png";
import { ATTACHMENT_URL } from "../../../utils/urls";
import instance from "../../../services/services";

function ACETrader(){
  const { t } = useLanguage();
  
   // 0: ACE Trader, 1: ACE eXchange, 2: ADLIB
  const [activeTab, setActiveTab] = useState(0);  
  const [adlibData, setAdlibData] = useState([]);
  const [traderData, setTraderData] = useState([]);
  const tabList = [
    { label: "ACE Trader", url: "/solutions/aceTrader" },
    { label: "ACE eXchange", url: "/solutions/aceExchange" },
    { label: "ACE ADLIB", url: "/solutions/adlib" },
  ];


  // 지원타겟팅 섹션
  const aceTraderTargets = t('sub_section_2.aceTrader_targets', []); // 다국어 배열 불러오기
  const targetBox = (aceTraderTargets || []).map((item, idx) => ({  // 이미지/번호 조합
    ...item,
    img: [sub_01, sub_02, sub_03, sub_04, sub_05, sub_06, sub_07, sub_08][idx],
    num: `0${idx + 1}`,
  }));


  //지원소재 및 포맷 섹션
  const formatList = t('sub_section_3.formats', []);
  const formatImages = [format_1, format_2, format_3];

  const creativeList = t('sub_section_3.images', []);
  const creativeImages = [format_4, format_5, format_6, format_7, format_8,];

  const videoList = t('sub_section_3.videos', []);
  const videoImages = [format_9, format_10, ];

  useEffect(()=> {
    const fetchAttachment = async () => {
      try {
        const response = await instance.post(ATTACHMENT_URL)
        setAdlibData(response.data.data.adlib);
        setTraderData(response.data.data.trader);
      }
      catch(error) {
        console.error('첨부파일 데이터 가져오기 실패:', error);
      }
    }
    fetchAttachment();
  }, []);
  
  return(
    <div className="solutions">
    {/* 배너 */}
      <SubBanner
        bgImg={bannerImg}
        logoImg={AceTraders}
        description={
          <span
            dangerouslySetInnerHTML={{
              __html: t('aceTrader.descriptionHtml')
            }}
          />
        }
        buttons={[
          { label: t('aceTrader.btn_1'), url: `https://admin.nhnace.com${traderData?.file_path}` },
          { label: t('aceTrader.btn_2'), url: "http://adcenter.toast.com/" }
        ]}
        tabs={tabList.map((tab,idx) => ({
          label : tab.label,
          url : tab.url,
          active: activeTab === idx,
          onClick: () => setActiveTab(idx),
        }))}
        location={[
          { label: "Solution", url: "/solution" },
          { label: "ACE Trader", url: "/solution/aceTrader", active: true }
        ]}
      />

      <section className="sub_section mt-[190px] mb-[120px] md:my-[160px] mx-auto md:mt-[240px]">
        <div className="sub_txt_box">
          <figure><img src={ace_dmp} alt="ace_dmp"/></figure>
          <span className="mt-[8px]">{t('sub_section_1.aceTrader_desc')}</span>
          <p dangerouslySetInnerHTML={{ __html: t('sub_section_1.aceTrader_con') }} />
        </div>
        <div className="mt-[80px]">
          <figure className="m-auto">
            <img src={dmp} alt="dmp" loading="lazy"/>
          </figure>
        </div>
      </section>


      <section className="mb-[120px] md:mb-[160px] mx-auto sub_page_bg">
        <div className="sub_txt_box">
          <h3 className="f_40 text-white">{t('sub_section_2.aceTrader_title')}</h3>
          <span className="mt-[10px]">{t('sub_section_2.aceTrader_desc')}</span>
        </div>

        <div className="target_container mt-[50px] md:mt-[80px] lg:mt-[120px] mx-auto mb-auto">
          <ul>
            {targetBox.map((target,idx) => (
              <li  className="target_box" key={idx}>
                <div className="t_top">
                  <img src={target.img} alt={`sub_0${idx+1}`}/>
                  <span>{target.num}</span>
                </div>
                <h4>{target.title}</h4>
                <p>{target.txt}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="sub_section my-[120px] md:my-[160px] mx-auto">
        <div className="sub_txt_box">
          <h3 className="f_40">{t('sub_section_3.aceTrader_title')}</h3>
          <span className="mt-[10px]">{t('sub_section_3.aceTrader_desc')}</span>
        </div>

        <div className="format_container mt-[50px] md:mt-[80px] mx-auto mb-auto bg-[#F2F3F5]">
          <p className="red_btn_txt">{t('red_btn.utilizing')}</p>
          <ul className="format_inner w-full flex flex-col gap-[20px]">
            {formatList.map((format,idx)=>(
              <li className="format_box" key={idx}>
                <div className="format_left">
                  <h4>{format.title}</h4>
                  <p>{format.description}</p>
                </div>
                <div className="format_right">
                  <img src={formatImages[idx]} alt={format.title} />
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="format_container mt-[50px] md:mt-[60px] mx-auto mb-auto bg-[#F2F3F5]">
          <p className="red_btn_txt">{t('red_btn.creative')}</p>
          <ul className="format_inner w-full flex flex-col gap-[20px]">
            {creativeList.map((format,idx)=>(
              <li className="format_box" key={idx}>
                <div className="format_left">
                  <h4>{format.title}</h4>
                  <p>{format.description}</p>
                </div>
                <div className="format_right">
                  <img src={creativeImages[idx]} alt={format.title} />
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="format_container mt-[50px] md:mt-[60px] mx-auto mb-auto bg-[#F2F3F5]">
          <p className="red_btn_txt">{t('red_btn.video')}</p>
          <ul className="format_inner w-full flex flex-col gap-[20px]">
            {videoList.map((format,idx)=>(
              <li className="format_box" key={idx}>
                <div className="format_left">
                  <h4>{format.title}</h4>
                  <p>{format.description}</p>
                </div>
                <div className="format_right">
                  <img src={videoImages[idx]} alt={format.title} />
                </div>
              </li>
            ))}
          </ul>
        </div>

        
      </section>
      

      <section className="sub_last bg-[#fff]">
        <div className="sub_last_inner">
          <div className="sub_left">
            <h3 className="f_40 text-left" dangerouslySetInnerHTML={{ __html: t('common_section.common_title') }} />
            <div className="banner_btn">
              <a
                href={`https://admin.nhnace.com${adlibData?.file_path}`}
                onClick={(e) => {
                  e.preventDefault(); // 기본 동작 방지
                  window.open(`https://admin.nhnace.com${traderData?.file_path}`, '_blank');
                }}
                style={{ cursor: 'pointer' }}
              >
                {t('aceTrader.btn_1')}
              </a>
              <a
                href="http://pubcenter.toast.com/"
                target="_blank"
                rel="noopener noreferrer"
              >                
                {t('aceTrader.btn_2')}
              </a>
            </div>
          </div>
          
          <div className="sub_right">
            <img src={subLast} alt="subLast" loading="lazy"/>
          </div>
        </div>
      </section>
    </div>
  )
};

export default ACETrader;
